import { Badge } from "@/components/ui/badge";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";
import { cn } from "@/lib/utils";
import type { SeverityLabel } from "@/trading/types";

type Props = { severity: SeverityLabel; className?: string };

const variantClass: Record<SeverityLabel, string> = {
  HIGH: "bg-destructive text-destructive-foreground hover:bg-destructive/90",
  MED: "bg-amber-500 text-amber-950 hover:bg-amber-500/90",
  LOW: "bg-secondary text-secondary-foreground hover:bg-secondary/90",
};

export function SeverityBadge({ severity, className }: Props) {
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Badge className={cn(variantClass[severity], "cursor-help", className)}>
          {severity}
        </Badge>
      </TooltipTrigger>
      <TooltipContent>
        Impact strength on this material: HIGH ≥80% relevance, MED ≥50%, LOW below.
        Different from the alert-bar 1–5 severity (alerts come from breaking-news rules;
        this comes from how relevant the news is).
      </TooltipContent>
    </Tooltip>
  );
}
